module.exports = __webpack_public_path__ + "static/media/add-icon.72fed30b.svg";